











import useBreadcrumb from '@/composables/useBreadcrumb'
import { defineComponent, computed, provide, watch } from '@vue/composition-api'
import { useRouter } from '@u3u/vue-hooks'
import PageHeaderNavigator from '@/components/PageHeaderNavigator.vue'
import { useQuery, useResult } from '@vue/apollo-composable'
import userQuery from '@/lib/graphql/user.query.gql'

export default defineComponent({
  components: {
    PageHeaderNavigator
  },

  setup(_, { root }) {
    const { route } = useRouter()

    // Breadcrumb setup
    const { setCurrentbreadcrumbName } = useBreadcrumb()
    setCurrentbreadcrumbName('/users/:id', `Edit User`)

    const navigationItems = computed(() => [
      {
        key: 'basic',
        title: 'Basic',
        route: {
          name: 'user.details.basic',
          params: route.value.params,
          query: route.value.query
        }
      },
      {
        key: 'membership',
        title: 'Membership',
        route: {
          name: 'user.details.membership',
          params: route.value.params,
          query: route.value.query
        }
      },
      {
        key: 'auth',
        title: 'Auth',
        route: {
          name: 'user.details.auth',
          params: route.value.params,
          query: route.value.query
        }
      },
      {
        key: 'devices',
        title: 'Devices',
        route: {
          name: 'user.details.devices',
          params: route.value.params,
          query: route.value.query
        }
      }
    ])

    const params = computed(() => ({
      id: route.value.params.id
    }))
    const { result, loading, error, onError, onResult } = useQuery(
      userQuery,
      params
    )
    const user = useResult(result)
    onError(error => {
      console.error(error)
      root.$notification.error({
        message: 'Error',
        description: 'An error occurred'
      })
    })

    watch(
      user,
      // eslint-disable-next-line
      (user: any) => {
        if (user) {
          setCurrentbreadcrumbName('/users/:id', user.name)
        }
      },
      { immediate: true }
    )

    provide('user', {
      data: user,
      loading,
      error,
      onResult
    })

    return {
      navigationItems
    }
  }
})
